<template>
  <a-config-provider :locale="language === 'English' ? enUS : zhCN">
    <div class="bule_list_page">
      <a-layout-content style="padding: 30px 30px">
        <a-form layout="inline">
          <a-form-item :label="langObj['关键词']">
            <a-input v-model:value="formState.keyword"/>
          </a-form-item>
          <a-form-item :label="langObj['分类']">
            <a-auto-complete v-model:value="formState.category" :options="categories"
                             allow-clear style="min-width: 200px"/>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="formState.skip = 1; search()">{{ langObj['搜索'] }}</a-button>
          </a-form-item>
          <a-form-item>
            <a-button v-if="isEditable" type="primary" @click="add">
              <template #icon>
                <plus-outlined/>
              </template>
              {{ langObj['新增'] }}
            </a-button
            >
          </a-form-item>
        </a-form>
        <div class="main">
          <a-table bordered :emptyText="langObj['暂无数据']" :columns="columns"
                   :data-source="dataSource" :pagination="pagination" @change="handleTableChange"
                   :loading="loading" size="small">
            <template #bodyCell="{ column, text, record }">
              <template v-if="column.dataIndex === 'act'">
                <a-button v-if="isEditable" type="primary" class="plft" @click="editThis(record)">
                  <edit-outlined/>
                  {{ langObj['编辑'] }}
                </a-button>

                <a-popconfirm :title="langObj['确定删除此条数据么']+'?'" :ok-text="langObj['确定']"
                              :cancel-text="langObj['取消']" @confirm="deleteThis(record)">
                  <a-button v-if="isShowDel" style="margin-left: 10px;" type="primary" danger>
                    <delete-outlined/>
                    {{ langObj['删除'] }}
                  </a-button>
                </a-popconfirm>

              </template>
            </template>
          </a-table>
        </div>
      </a-layout-content>
      <a-modal :width="850" :maskClosable="false" :title="modalState.title"
               v-model:visible="modalState.visible"
               :confirm-loading="modalState.confirmLoading"
               :cancelText="langObj['取消']" :okText="langObj['确认']" @ok="handleOk">
        <a-form ref="formStateRef" :model="form" name="basic" autocomplete="off"
                :label-col="{ style: { width: '180px' } }">
          <a-form-item :label="langObj['键']" name="key" required>
            <a-input v-model:value="form.key"/>
          </a-form-item>
          <a-form-item :label="langObj['中文']" name="zh" required>
            <a-input v-model:value="form.zh"/>
          </a-form-item>
          <a-form-item :label="langObj['英文']" name="en" >
            <a-input v-model:value="form.en"/>
          </a-form-item>
          <a-form-item :label="getLanguage('繁体')" name="ft" >
            <a-input v-model:value="form.ft"/>
          </a-form-item>
          <a-form-item :label="langObj['分类']" name="category">
            <a-auto-complete v-model:value="form.category" :options="categories"/>
          </a-form-item>
        </a-form>
      </a-modal>
    </div>
  </a-config-provider>
</template>

<script lang="ts" setup>
import request from "../../common/request";
import { computed, onMounted } from "vue";
import { ref, reactive } from "vue";
import { langList } from "@/common/lang";
import enUS from "ant-design-vue/es/locale/en_US";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons-vue'

const loading = ref(false);
import { v4 as uuidv4 } from "uuid";
import { message } from "ant-design-vue";
import { getLanguage } from "@/common/translate";

let langObj: any = ref({})
let language: any = ref('English')
const getLang = () => {
   language.value = 'English'
  langObj.value = langList[language.value]
}
getLang()

const formState = reactive({
  keyword: "",
  category: "",
  skip: 1,
  take: 10,
});
let total = ref(0);
let pagination = computed(() => ({
  total: total.value,
  current: formState.skip,
  pageSize: formState.take,
}));

const handleTableChange = (pagination: any, _filters: any, _sorter: any) => {
  formState.skip = pagination.current;
  formState.take = pagination.pageSize
  search();
};

const categories = ref<any[]>([
  { value: "sensorName", label: "sensorName" },
  { value: "machineName", label: "machineName" },
  { value: "groupName", label: "groupName" },
  { value: "factoryName", label: "factoryName" },
]);

let form: any = ref({
  key: "",
  category: "",
  zh: "",
  en: "",
});

const modalState = reactive({
  visible: false,
  title: langObj.value["新增"],
  confirmLoading: false,
});

const formStateRef = ref();

const dataSource = ref([]);
const columns = [
  {
    title: langObj.value["键"],
    dataIndex: "key",
    align: "center",
  },
  {
    title: langObj.value["中文"],
    dataIndex: "zh",
    align: "center",
  },
  {
    title: langObj.value["英文"],
    dataIndex: "en",
    align: "center",
  },
  {
    title: getLanguage('繁体'),
    dataIndex: "ft",
    align: "center",
  },
  {
    title: langObj.value["分类"],
    dataIndex: "category",
    align: "center",
  },
  {
    title: langObj.value["操作"],
    dataIndex: "act",
    with: 120,
    align: "center",
  }
];

const add = () => {
  formStateRef.value?.clearValidate();
  modalState.title = langObj.value["新增"];
  form.value = {
    key: "",
    category: "",
    zh: "",
    en: "",
  };
  modalState.visible = true;
};

const editThis = (val: any) => {
  formStateRef.value?.clearValidate();
  modalState.title = langObj.value["编辑"];
  form.value = JSON.parse(JSON.stringify(val));

  modalState.visible = true;
};

// 保存
const handleOk = () => {
  formStateRef.value?.clearValidate();
  formStateRef.value
      .validate()
      .then((_: any) => {
        if (form.value.id) {
          request
              .put("/api/translations", form.value)
              .then((res) => {
                if (res) {
                  modalState.visible = false;
                  message.success(getLanguage("操作成功"));
                  search();
                }
              });
        } else {
          request
              .post("/api/translations", form.value)
              .then((res) => {
                if (res) {
                  modalState.visible = false;
                  message.success(getLanguage("操作成功"));
                  search();
                }
              });
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
};

// 删除
const deleteThis = (ev: any) => {
  const config = {
    params: {
      id: ev.id
    },
    headers: {
      requestId: uuidv4(),
    },
  };
  request
      .delete("/api/translations", config)
      .then((res) => {
        if (res) {
          message.success(getLanguage("操作成功"));
          formState.skip = 1
          search();
        } else {
          message.warning("操作失败");
        }
      });
}

// 查询
const search = () => {
  const config = {
    params: formState,
    headers: {
      requestId: uuidv4(),
    },
  };
  request.get("/api/translations", config).then((res: any) => {
    if (res) {
      dataSource.value = res.data.list;
      total.value = res.data.count;
    }
  });
};

let isShowDel: any = ref(false)
const getMemberInfo = async () => {
  let result = await request.get("/api/members/info")
  if (result?.data?.admin) {
    isShowDel.value = true
  }
}
let isEditable: any = ref(false)
// 在组件加载完成后执行一些操作
onMounted(async () => {
  request.get("/api/translations/categories").then((res: any) => {
    if (res?.data) {
      categories.value = res.data.map((item: any) => {
        return { value: item, label: item };
      });
    }
  });
  getMemberInfo().catch(() => { })
  search();
});

</script>
<style scoped>
.main {
  margin-top: 30px;
}

.bule_list_page {
  height: calc(100vh - 100px) !important;
}
</style>
